import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AddAppointmentModal from '../appointmentmanagment/addappointment'; // Le composant modal
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
} from '@coreui/react';
import { FaArrowLeft } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import axios from 'axios';
import { format } from "date-fns";
import Adminprofil from '../../../assets/images/adminprofil.png';
import folderempty from '../../../assets/images/Group 207.png';
import api from '../../../service/caller';
import { toast } from 'react-toastify';

const Patientfilemedical = () => {
  const [UserData, setUserData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [ticket, setticket] = useState(false);
  const { patientId } = useParams();
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [medicalHistories, setMedicalHistory] = useState([]);
  const [selectedConsultation, setSelectedConsultation] = useState(null); // État pour les détails de la consultation
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPatientData = async () => {
      try {
        const response = await api.get(`/clinic/getpatient/${patientId}`);
        setPatientData(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des données du patient:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
  }, [patientId]);

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');

        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  useEffect(() => {
    async function fetchMedicalHistory() {
      try {
        const response = await api.get(`clinic/medicalhistory/${patientId}`);
        setMedicalHistory(response.data);
        setLoading(false);
      } catch (error) {
        setError('Une erreur est survenue lors de la récupération de l\'historique médical.');
        setLoading(false);
      }
    }

    fetchMedicalHistory();
  }, [patientId]);

  const handleAppointmentAdded = (newAppointment) => {
    setAppointments((prev) => [...prev, newAppointment]);
  };

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const upcomingAppointment = {
    doctor: `Dr. ${medicalHistories[medicalHistories.length - 1]?.ConsultationId.doctorId.firstname} ${medicalHistories[medicalHistories.length - 1]?.ConsultationId.doctorId?.lastname}`,
    date: `${new Date(medicalHistories[medicalHistories.length - 1]?.consultationDate).toLocaleDateString('fr-FR')}`,
    time: `${new Date(medicalHistories[medicalHistories.length - 1]?.consultationDate).toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })}`
  };
  const [patientPresent, setPatientPresent] = useState(null);

  const handlePresenceResponse = (isPresent) => {
    setPatientPresent(isPresent);
    // Logique supplémentaire au besoin
  };

  const styles = {
    container: {
      padding: '1.5rem',
      minHeight: '100vh'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      padding: '1.5rem'
    },
    title: {
      color: '#2563EB',
      fontSize: '42px',
      fontWeight: 'bold',
      marginBottom: '1.5rem'
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      color: '#2563EB',
      border: 'solid blue 2px',
      background: 'none',
      cursor: 'pointer',
      borderRadius: "15px",
      height: "50px",
      width: "100px",
      marginBottom: '1.5rem'
    },
    sectionTitle: {
      borderLeft: '4px solid #22C55E',
      paddingLeft: '1rem',
      marginBottom: '0.5rem'
    },
    sectionTitleText: {
      fontSize: "18px",
      color: '#4B5563',
      fontWeight: '500'
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '1rem',
      marginTop: '1rem',
      marginBottom: '2rem'
    },
    label: {
      color: '#4B5563',
      fontSize: '0.875rem',
      marginBottom: '0.25rem'
    },
    value: {
      fontWeight: 'bold'
    },
    tableContainer: {
      backgroundColor: '#28A7452B',
      borderRadius: '0.5rem',
      padding: '1rem'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    th: {
      textAlign: 'left',
      paddingBottom: '1rem',
      color: '#4B5563',
      fontSize: '0.875rem',
      fontWeight: 'normal'
    },
    td: {
      padding: '0.5rem 0',
      color: '#374151'
    },
    container: {
      padding: '1.5rem',
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      fontFamily: 'Arial, sans-serif'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      padding: '1.5rem',
      marginBottom: '1rem'
    },
    title: {
      color: '#2563EB',
      fontSize: '1.75rem',
      fontWeight: 'bold',
      marginBottom: '1.5rem'
    },
    sectionHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1.25rem',
      paddingBottom: '0.25rem'
    },
    sectionMarker: {
      width: '16px',
      height: '3px',
      backgroundColor: '#22C55E',
      marginRight: '0.75rem'
    },
    sectionTitle: {
      color: '#4B5563',
      fontSize: '1rem',
      fontWeight: '600',
      margin: 0
    },
    patientDetailsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '1rem',
      marginBottom: '1.5rem'
    },
    label: {
      color: '#6B7280',
      fontSize: '0.875rem',
      marginBottom: '0.25rem'
    },
    value: {
      fontWeight: 'bold',
      color: '#111827',
      fontSize: '0.9375rem'
    },
    noteContainer: {
      backgroundColor: '#FFF8E1',
      borderRadius: '0.5rem',
      padding: '0.75rem 1rem',
      margin: '1rem 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    noteLeftContent: {
      display: 'flex',
      alignItems: 'center'
    },
    noteLabel: {
      color: '#FF9800',
      fontWeight: 'bold',
      marginRight: '0.5rem'
    },
    noteText: {
      margin: 0,
      fontSize: '0.9375rem'
    },
    radioButton: {
      width: '18px',
      height: '18px',
      cursor: 'pointer',
      marginRight: '0.75rem'
    },
    infoIcon: {
      color: '#FF9800',
      fontSize: '1.25rem',
      cursor: 'pointer'
    },
    patientPresenceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0.5rem 0',
      margin: '0.5rem 0 1.5rem'
    },
    patientPresenceButtons: {
      display: 'flex',
      gap: '0.5rem'
    },
    presenceButton: {
      padding: '0.375rem 1.5rem',
      borderRadius: '0.25rem',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none'
    },
    noButton: {
      backgroundColor: '#111827',
      color: 'white'
    },
    yesButton: {
      backgroundColor: '#FF9800',
      color: 'white'
    },
    tableContainer: {
      backgroundColor: 'rgba(40, 167, 69, 0.17)',
      borderRadius: '0.5rem',
      padding: '1rem',
      marginTop: '1rem'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    tableHeader: {
      backgroundColor: 'white',
      margin: '5px',
      padding: '7px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'normal',
      fontSize: '0.875rem',
      color: '#4B5563'
    },
    arrowIcon: {
      marginLeft: '0.25rem'
    },
    tableRow: {
      borderBottom: '1px solid rgba(229, 231, 235, 0.5)'
    },
    tableCell: {
      padding: '0.75rem 0.5rem',
      textAlign: 'center',
      color: '#374151',
      fontSize: '0.875rem'
    },
    eyeIcon: {
      color: '#22C55E',
      cursor: 'pointer'
    },
    backButton: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0.5rem 1rem',
      backgroundColor: 'transparent',
      border: '1px solid #2563EB',
      borderRadius: '0.375rem',
      color: '#2563EB',
      cursor: 'pointer',
      marginBottom: '1.5rem',
      fontWeight: '500',
      fontSize: '0.875rem'
    },
    newAppointmentButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#2563EB',
      color: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      gap: '0.5rem',
      position: 'absolute',
      top: '1.5rem',
      right: '1.5rem',
      cursor: 'pointer',
      fontWeight: '500',
      border: 'none'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: showModal ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      padding: '1.5rem',
      maxWidth: '450px',
      width: '100%'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1rem',
      borderBottom: '1px solid #E5E7EB',
      paddingBottom: '0.75rem'
    },
    modalTitle: {
      margin: 0,
      fontSize: '1.25rem',
      fontWeight: 'bold',
      color: '#111827'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1.5rem',
      color: '#6B7280'
    },
    modalBody: {
      marginBottom: '1.5rem'
    },
    modalFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '0.75rem',
      borderTop: '1px solid #E5E7EB',
      paddingTop: '1rem'
    }
  };

  // const handleViewDetails = (consultation) => {
  //     setSelectedConsultation(consultation); // Sélectionner la consultation à afficher
  // };

  if (loading) {
    return <p>Chargement...</p>;
  }

  // Patientfilemedical.js
  const handleViewDetails = (medicalHistorie) => {
    // Récupérer l'ID de la consultation depuis medicalHistorie
    const consultationId = medicalHistorie.ConsultationId._id;

    // Naviguer vers la page des détails de la consultation
    navigate(`/hospitaladmin/consultation-details/${consultationId}`);
  };


  return (
    <div className="dashboard-header">
      <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
        <div className="hosp-header__content">
          {/* Titre à gauche */}
          <div className="hosp-header__title">
            <h4 className="hosp-page__title"><b>Patient Management</b></h4>
          </div>

          {/* Profil utilisateur à droite */}
          <div className="hosp-user__profile">
            {/* Indicateur de statut en ligne (optionnel) */}
            <div className="hosp-status__indicator"></div>

            <img src={UserData?.picture || Adminprofil} className='hosp-profile__image'  alt="Consultation Icon" />

            <div className="hosp-user__details">
              <span className="ms-2" style={{ color: 'black', fontSize: '18px' }} >{UserData.firstname} {UserData.lastname}</span>
              <p className="ms-2" style={{ color: 'black', fontSize: '18px', display: 'flex', flexWrap: 'wrap' }} >{UserData.role?.name}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="Patientlist filemedical mt-4">
        <div className='tabsection'>
          <CRow>
            <CCol xs={12}>
              <CCard className="card mb-4 p-4">
                <CCardBody>
                  <div className='row'>
                    <div className="col-12 col-md-4 col-lg-3 mb-3">
                      <CButton className="btn btn-primary rounded-pill w-100" style={{ padding: '10px 20px', background: '#0056B3' }} onClick={() => (navigate(-1) || navigate('/'))}>
                        <FaArrowLeft /> Retour
                      </CButton>
                    </div>
                    <div className='col-md-4 col-lg-6'></div>
                    <div className='col-12 col-md-4 col-lg-3 mb-3'>
                      <CButton onClick={() => setVisible(!visible)} className="btn btn-primary rounded-pill w-100" style={{ padding: '10px 20px', background: '#0056B3' }} active tabIndex={-1}>
                        <BsPersonPlus className='mx-2' /> New Appointment
                      </CButton>
                    </div>
                  </div>

                  <AddAppointmentModal
                    visible={visible}
                    onClose={() => setVisible(false)}
                    onAppointmentAdded={handleAppointmentAdded} patientId={patientId} patientfirstName={patientData?.firstname} patientlastName={patientData?.lastname}
                  />

                  <div className='patientdetails'>
                    <div className='d-flex align-items-center cardheader mb-5'>
                      <span className='me-3' style={{ width: '70px', height: '5px', background: 'green' }}></span>
                      <h4>Medical history</h4>
                    </div>

                    {patientData ? (
                      <CRow className="my-3 patientinfo mb-5">
                        <CCol xs={12} md={2}>
                          <div className="flexcoldisposition">
                            <p>Name :</p>
                            <p><b>{patientData?.firstname} {patientData?.lastname}</b></p>
                          </div>
                        </CCol>
                        <CCol xs={12} md={2}>
                          <div className="flexcoldisposition">
                            <p>Email : </p>
                            <p><b>{patientData?.email}</b></p>
                          </div>
                        </CCol>
                        <CCol xs={12} md={2}>
                          <div className="flexcoldisposition">
                            <p>Date of birth: </p>
                            <p><b>{patientData?.age.split("T")[0]}</b></p>
                          </div>
                        </CCol>
                        <CCol xs={12} md={2}>
                          <div className="flexcoldisposition">
                            <p>Address : </p>
                            <p><b>{patientData?.address}</b></p>
                          </div>
                        </CCol>
                        <CCol xs={12} md={2}>
                          <div className="flexcoldisposition">
                            <p>Gender :</p>
                            <p><b>{patientData?.gender}</b></p>
                          </div>
                        </CCol>
                      </CRow>

                    ) : (
                      <p>No data available</p>
                    )}
                    {upcomingAppointment.length > 0 && (<div style={styles.noteContainer}>
                      <div style={styles.noteLeftContent}>
                        {/* <input 
                                                type="radio" 
                                                style={styles.radioButton}
                                                onClick={toggleModal}
                                                id="appointmentRadio"
                                                name="appointmentRadio"
                                                aria-label="Show appointment details"
                                            /> */}
                        <div>
                          <span style={styles.noteLabel}>NOTE :</span>
                          <span style={styles.noteText}>
                            Control with {upcomingAppointment.doctor}, {upcomingAppointment.date} by {upcomingAppointment.time}
                          </span>
                        </div>
                      </div>
                      <div>
                        {/* <i className="bi bi-info-circle" style={styles.infoIcon}></i> */}
                      </div>
                    </div>)}
                  </div>

                  <div className='mt-5'>
                    <div className='d-flex align-items-center cardheader'>
                      <span className='me-3' style={{ width: '70px', height: '5px', background: 'green' }}></span>
                      <h4>Medical history</h4>
                    </div>

                    {medicalHistories.length > 0 ? (
                      <div style={styles.tableContainer}>
                        <table style={styles.table}>
                          <thead>
                            <tr>
                              <th className='text-center' style={styles.th}>#</th>
                              <th className='text-center' style={styles.th}>Last Visit</th>
                              <th className='text-center' style={styles.th}>Type</th>
                              <th className='text-center' style={styles.th}>Doctor</th>
                              <th className='text-center' style={styles.th}>Services</th>
                              <th className='text-center' style={styles.th}>Voir détails</th>
                            </tr>
                          </thead>
                          <tbody>
                            {medicalHistories.map((medicalHistorie) => (
                              <tr key={medicalHistorie.id}>
                                <td className='text-center' style={styles.td}>{medicalHistorie.id}</td>
                                <td className='text-center' style={styles.td}>{new Date(medicalHistorie?.consultationDate).toISOString().split('T')[0]}</td>
                                <td className='text-center' style={styles.td}>{medicalHistorie?.AppointmentId.motif}</td>
                                <td className='text-center' style={styles.td}>{medicalHistorie?.ConsultationId.doctorId.firstname} {medicalHistorie?.ConsultationId.doctorId.lastname}</td>
                                <td className='text-center' style={styles.td}>{medicalHistorie?.ConsultationId.services.map(service => service?.name).join(', ')}</td>
                                {/* <td className='text-center text-success' style={styles.td}>
                                                                    <i className="bi bi-eye" onClick={() => handleViewDetails(medicalHistorie)}></i>
                                                                </td> */}
                                <td className='text-center text-success' style={styles.td}>
                                  <i className="bi bi-eye" onClick={() => handleViewDetails(medicalHistorie)} style={{ cursor: 'pointer' }}></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className='d-flex align-items-center justify-content-center' style={{ height: '300px' }}>
                        <h4>No medical history yet</h4>
                        <img src={folderempty} className='cardicon' alt="Consultation Icon" width={'100'} height={'100'} />
                      </div>
                    )}
                  </div>

                  {/* Affichage des détails de la consultation sélectionnée */}
                  {selectedConsultation && (
                    <div className="detailSection">
                      <h5>Details for Consultation ID: {selectedConsultation.id}</h5>
                      <p><strong>Date of Consultation:</strong> {new Date(selectedConsultation?.consultationDate).toISOString().split('T')[0]}</p>
                      <p><strong>Doctor:</strong> {selectedConsultation.ConsultationId.doctorId}</p>
                      <p><strong>Services:</strong> {selectedConsultation.ConsultationId.services.map(service => service.name).join(', ')}</p>
                      <p><strong>Notes:</strong> {selectedConsultation.ConsultationId.notes || 'No notes available'}</p>
                    </div>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      </div>
      <div style={styles.modalOverlay}>
        <div style={styles.modalContent}>
          <div style={styles.modalHeader}>
            <h3 style={styles.modalTitle}>Confirmation</h3>
            <button style={styles.closeButton} onClick={toggleModal}>×</button>
          </div>
          <div style={styles.modalBody}>
            <p style={{ margin: 0 }}>Confirmer la présence du patient à ce rendez-vous ?</p>
          </div>
          <div style={styles.modalFooter}>
            <button
              style={{ ...styles.presenceButton, backgroundColor: '#000000', color: '#4B5563' }}
              onClick={toggleModal}
            >
              NO
            </button>
            <button
              style={{ ...styles.presenceButton, backgroundColor: '#2563EB', color: 'white' }}
              onClick={() => {
                handlePresenceResponse(true);
                toggleModal();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Patientfilemedical;
